
// import {AuthMethods, AuthProviders} from "angularfire2";

export const firebaseConfig = {
  apiKey: "AIzaSyA1Ys0m2ixPmpV9O_X5r5K8rfCEuAIXF7c",
  authDomain: "srvpls-ptt1.firebaseapp.com",
  databaseURL: "https://srvpls-ptt1.firebaseio.com",
  storageBucket: "srvpls-ptt1.appspot.com",
  messagingSenderId: "1067913802499"
};


/*

export const authConfig = {
    provider: AuthProviders.Password,
    method: AuthMethods.Password
};
*/



// WEBPACK FOOTER //
// ./src/environments/firebase.config.ts